module.exports = __webpack_public_path__ + "img/1542453381.cca44f3c.jpg";